import { AppConfigMapper } from './app-config-mapper';

export const appConfig = AppConfigMapper.toAppConfig(process.env);
